import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  CheckSelector,
  InputOutput,
  SingleCheckSelector,
} from "../components/GuiElements";
import { useHistory } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";

const PlayerSelect = ({
  setCurrentPlayer,
  currentPlayer,
  setCurrentGame,
  currentGame,
  setGameSettings,
  gameSettings,
  setSettings,
  settings,
  allPlayers,
  setAllPlayers,
  savedPlayers,
  userId,
  onlineCheck,
  setOnlineCheck,
}) => {
  const history = useHistory();
  const [check, setCheck] = useState(true);
  const [inverseCheck, setInverseCheck] = useState(false);

  const dropdownmenu = savedPlayers;

  const [player1, setPlayer1] = useState("Spieler 1");
  const [player2, setPlayer2] = useState("Spieler 2");
  const [player3, setPlayer3] = useState("Spieler 3");
  const [player4, setPlayer4] = useState("Spieler 4");

  useEffect(() => {
    if (!gameSettings.spieleranzahl) {
      history.push("/");
    }
    let players = [];
    let i;
    for (i = 0; i < gameSettings.spieleranzahl; i++) {
      players = [...players, { name: `Spieler ${i + 1}`, game: [] }];
    }
    setAllPlayers(players);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameSettings]);

  useEffect(() => {
    let players = [];
    gameSettings.spieleranzahl >= 1 &&
      players.push({ name: player1, game: [] });
    gameSettings.spieleranzahl >= 2 &&
      players.push({ name: player2, game: [] });
    gameSettings.spieleranzahl >= 3 &&
      players.push({ name: player3, game: [] });
    gameSettings.spieleranzahl >= 4 &&
      players.push({ name: player4, game: [] });
    setAllPlayers(players);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player1, player2, player3, player4]);

  useEffect(() => {
    setGameSettings({
      ...gameSettings,
      order: inverseCheck ? "random" : "following",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inverseCheck]);

  return (
    <Card
      style={{
        minHeight: inverseCheck ? "35rem" : "24rem",
        background: !settings.darkmode
          ? "var(--main-dark-color)"
          : "var(--main-light-color)",
      }}
    >
      <span
        style={{
          color: !settings.darkmode
            ? "var(--main-light-color)"
            : "var(--main-dark-color)",
        }}
        onClick={() => {
          history.push("/newgame");
        }}
        className="back"
      >
        {"<"}&nbsp;&nbsp;&nbsp;
      </span>
      <h1
        className="players-title"
        style={{ color: !settings.darkmode ? "#fff" : "#000" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="51.503"
          height="51.5"
          viewBox="0 0 51.503 51.5"
        >
          <path
            id="Pfad_4"
            data-name="Pfad 4"
            d="M43.5,7.781A25.24,25.24,0,1,0,7.77,43.428c.014.014.02.036.034.049.146.141.3.26.453.395.406.361.811.734,1.239,1.082.229.18.467.361.7.526.4.3.808.6,1.23.88.287.18.582.361.876.541.389.234.777.471,1.179.685.341.18.689.335,1.035.5.379.18.752.361,1.14.523s.777.289,1.17.429.732.27,1.109.386c.426.128.862.227,1.295.334.361.088.71.189,1.082.261.5.1,1,.162,1.507.231.312.043.617.1.932.135.826.081,1.659.126,2.5.126s1.673-.045,2.5-.126c.316-.031.62-.092.932-.135.5-.069,1.01-.132,1.507-.231.361-.072.721-.18,1.082-.261.433-.106.869-.206,1.295-.334.377-.115.741-.256,1.109-.386s.786-.27,1.17-.429.761-.344,1.14-.523c.346-.164.694-.319,1.035-.5.4-.215.79-.451,1.179-.685.294-.18.59-.344.876-.541.422-.278.826-.579,1.23-.88.234-.18.472-.343.7-.526.427-.343.833-.707,1.239-1.082.148-.135.306-.254.453-.395.014-.013.02-.034.034-.049A25.212,25.212,0,0,0,43.5,7.781ZM39.443,41.54c-.328.289-.667.563-1.01.828-.2.155-.4.308-.611.456-.326.236-.658.46-1,.674-.245.157-.5.308-.748.456q-.476.271-.966.541c-.289.148-.582.287-.878.424s-.622.283-.941.411-.658.249-.992.361c-.3.1-.609.213-.918.3-.361.108-.737.2-1.111.287-.292.068-.581.146-.876.2-.427.083-.864.141-1.3.2-.249.032-.5.078-.747.1-.692.067-1.394.106-2.1.106s-1.41-.04-2.1-.106c-.251-.025-.5-.07-.747-.1-.438-.059-.874-.117-1.3-.2-.3-.058-.584-.135-.876-.2-.373-.09-.745-.18-1.111-.287-.308-.092-.613-.2-.918-.3-.334-.115-.667-.233-.992-.361s-.631-.269-.941-.411-.59-.276-.878-.424c-.326-.169-.649-.348-.966-.541-.252-.148-.5-.3-.748-.456-.337-.215-.669-.438-1-.674-.207-.148-.409-.3-.611-.456-.343-.265-.682-.541-1.01-.828-.079-.059-.151-.135-.229-.2a14.466,14.466,0,0,1,9.832-13.514,10.691,10.691,0,0,0,9.185,0,14.466,14.466,0,0,1,9.832,13.514C39.592,41.405,39.52,41.474,39.443,41.54ZM18.956,14.467a7.212,7.212,0,1,1,9.821,9.821.038.038,0,0,0-.031.011,7.639,7.639,0,0,1-1.507.638c-.094.027-.18.063-.279.087-.18.047-.37.079-.555.112a7.3,7.3,0,0,1-1.058.106h-.206a7.3,7.3,0,0,1-1.058-.106c-.18-.032-.371-.065-.555-.112-.1-.023-.18-.059-.279-.087A7.633,7.633,0,0,1,21.74,24.3l-.032-.011A7.212,7.212,0,0,1,18.956,14.467ZM42.867,37.761h0a18.12,18.12,0,0,0-9.654-12.428,10.818,10.818,0,1,0-15.939,0A18.121,18.121,0,0,0,7.621,37.761a21.637,21.637,0,1,1,35.246,0Z"
            transform="translate(0.5 0.489)"
            stroke={!settings.darkmode ? "#fff" : "#000"}
            strokeWidth="1"
            fill={!settings.darkmode ? "#fff" : "#000"}
          />
        </svg>
        {gameSettings.spieleranzahl > 1
          ? "Namen und Abfolge der Spieler"
          : "Name des Spielers"}
      </h1>
      <div className="players">
        {gameSettings.spieleranzahl >= 1 && (
          <InputOutput
            input
            title={`Spieler 1`}
            align={"left"}
            width={"100%"}
            placeholder={"Name"}
            dropdown={dropdownmenu}
            state={player1}
            setState={setPlayer1}
            key={"1"}
            darkmode={!settings.darkmode}
          />
        )}
        {gameSettings.spieleranzahl >= 2 && (
          <InputOutput
            input
            title={`Spieler 2`}
            align={"left"}
            width={"100%"}
            placeholder={"Name"}
            dropdown={dropdownmenu}
            state={player2}
            setState={setPlayer2}
            key={"2"}
            darkmode={!settings.darkmode}
          />
        )}
        {gameSettings.spieleranzahl >= 3 && (
          <InputOutput
            input
            title={`Spieler 3`}
            align={"left"}
            width={"100%"}
            placeholder={"Name"}
            dropdown={dropdownmenu}
            state={player3}
            setState={setPlayer3}
            key={"3"}
            darkmode={!settings.darkmode}
          />
        )}
        {gameSettings.spieleranzahl >= 4 && (
          <InputOutput
            input
            title={`Spieler 4`}
            align={"left"}
            width={"100%"}
            placeholder={"Name"}
            dropdown={dropdownmenu}
            state={player4}
            setState={setPlayer4}
            key={"4"}
            darkmode={!settings.darkmode}
          />
        )}
      </div>

      {gameSettings.spieleranzahl > 1 && (
        <div className="playmode">
          <h3 style={{ color: !settings.darkmode ? "#fff" : "#000" }}>
            Reihenfolge:
          </h3>
          <CheckSelector
            label={"Fortlaufend"}
            setState={setCheck}
            state={check}
            setInfluencer={setInverseCheck}
            marginR={"1rem"}
            darkmode={!settings.darkmode}
          />
          <CheckSelector
            label={"Zufällig"}
            setState={setInverseCheck}
            state={inverseCheck}
            setInfluencer={setCheck}
            darkmode={!settings.darkmode}
          />
        </div>
      )}
      {userId && (
        <div className="online">
          <h3 style={{ color: !settings.darkmode ? "#fff" : "#000" }}>
            Online:
          </h3>
          <SingleCheckSelector
            label={"Dieses Spiel online übetragen"}
            setState={setOnlineCheck}
            state={onlineCheck}
            darkmode={!settings.darkmode}
          />
        </div>
      )}
      {userId && onlineCheck && (
        <h4
          className="onlineId"
          style={{ color: !settings.darkmode ? "#fff" : "#000" }}
        >
          ID: {userId}
          <CopyToClipboard text={userId}>
            <span
              onClick={(e) => {
                e.target.innerText = "KOPIERT!";
                setTimeout(() => {
                  e.target.innerText = "ID KOPIEREN";
                }, 2000);
              }}
            >
              ID KOPIEREN
            </span>
          </CopyToClipboard>
          <CopyToClipboard
            text={
              "https://stahlspicker.tnstudios.de/online?id=" +
              userId.toLowerCase()
            }
          >
            <span
              onClick={(e) => {
                e.target.innerText = "KOPIERT!";
                setTimeout(() => {
                  e.target.innerText = "LINK KOPIEREN";
                }, 2000);
              }}
            >
              LINK KOPIEREN
            </span>
          </CopyToClipboard>
        </h4>
      )}

      <button
        onClick={() => {
          onlineCheck ? history.push("/onlinegame") : history.push("/game");
        }}
        className="blue-btn players-forwards"
      >
        {onlineCheck ? "Online Spiel starten" : "Spiel starten"}
      </button>
    </Card>
  );
};

const Card = styled.div`
  width: 100%;
  height: 100vh;
  min-width: 13rem;
  min-height: 40rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  animation: pageSlideInTransition 0.2s forwards;
  .back {
    position: absolute;
    top: 0.5rem;
    left: 2rem;
    font-size: 1.5rem;
    font-weight: 700;
    cursor: pointer;
  }
  .players {
    width: 22rem;
  }
  .players-title {
    font-size: 1.5rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    margin-bottom: 2rem;

    svg {
      width: 2rem;
      height: 2rem;
      margin-right: 0.5rem;
    }
  }
  .selectors {
    width: 22rem;
    margin-bottom: 0.5rem;
  }
  .playmode {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    h3 {
      margin-right: 1rem;
      font-weight: 300;
    }
  }
  .online {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    width: 22rem;

    padding-left: 0.7rem;
    h3 {
      display: none;
    }

    @media (max-width: 25rem) {
      padding-left: 0rem;
      h3 {
        display: block;
      }
    }
  }
  .onlineId {
    margin-bottom: 1rem;
    font-size: 1.2rem;
    font-weight: 600;
    user-select: text;
    display: flex;
    flex-direction: column;
    align-items: center;
    span {
      font-size: 0.8rem;
      opacity: 0.8;
      cursor: pointer;
    }
    animation: selectorsIn 0.3s forwards;
    overflow: hidden;
    @keyframes selectorsIn {
      from {
        height: 0;
      }
      to {
        height: 4rem;
      }
    }
  }
  .players-forwards {
    width: 22rem;
    margin: 0.5rem;
  }

  @media (max-width: 30rem) {
    .players-title {
      flex-direction: column;
      text-align: center;
    }
  }

  @media (max-width: 25rem) {
    .selectors,
    .players-forwards,
    .playmode,
    .players,
    .online {
      width: calc(100% - 1rem);
    }
    .playmode {
      flex-direction: column;
    }
  }
`;

export default PlayerSelect;
